import { errorResponse } from "src/app/interfaces/errorResponse";

export const parseErrorMessage = (error: errorResponse): string => {
  const body = error?.error as { message?: string; errorMessage?: string } | undefined;
  const errorMessage = body?.message ?? body?.errorMessage ?? error?.errorMessage;
  if (!errorMessage) return "apiError";

  const lowerErrorMessage = String(errorMessage).toLowerCase();
  if (lowerErrorMessage.includes("same username")) return "existingUsername";
  if (lowerErrorMessage.includes("same email")) return "existingEmail";
  if (lowerErrorMessage.includes("error-user-attribute-read-only") || lowerErrorMessage.includes("read-only")) return "readOnlyAttribute";
  return "apiError";
};
